import Auth from 'dashboard/api/auth';

const AUTH_HEADER_NAMES = [
  'access-token',
  'token-type',
  'client',
  'expiry',
  'uid',
];

export const setDirectUploadAuthHeaders = xhr => {
  const authData = Auth.getAuthData() || {};

  AUTH_HEADER_NAMES.forEach(headerName => {
    if (authData[headerName]) {
      xhr.setRequestHeader(headerName, authData[headerName]);
    }
  });
};
